import { createReducer } from '@reduxjs/toolkit';

import postArticles, { clearPostArticlesData } from '../../thunks/articles/postArticles';

const initialState = {
  loading: false,
  error: '',
  data: null,
};

const postArticlesReducer = createReducer(initialState, {
  [postArticles.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [postArticles.fulfilled]: (state, { payload }) => ({
    ...state,
    loading: false,
    data: payload,
  }),
  [clearPostArticlesData]: () => initialState,
  [postArticles.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
  }),
});

export default postArticlesReducer;
